import { hasOwnProperty } from "./runtime";
import { typeOf } from "./types";
export function merge(target, ...sources) {
    if (0 === sources.length) {
        return target;
    }
    if (1 < sources.length) {
        let result = target;
        for (let i = 0; i < sources.length; i++) {
            result = merge(result, sources[i]);
        }
        return result;
    }
    const source = sources[0];
    const sourceType = typeOf(source);
    const targetType = typeOf(target);
    if (sourceType === targetType || "null" === sourceType || "null" === targetType) {
        if ("array" === targetType) {
            return target.concat(source);
        }
        if ("object" === targetType) {
            for (const key in source) {
                target[key] = (target[key] !== undefined)
                    ? merge(target[key], source[key])
                    : source[key];
            }
            return target;
        }
        return source;
    }
    return target;
}
export function extend(source, ...sources) {
    const target = {};
    sources.unshift(source);
    for (let i = 0; i < sources.length; i++) {
        let source = sources[i];
        for (const key in source) {
            if (hasOwnProperty(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
}
